export default __webpack_public_path__ + "static/assets/eaef6f94445e6998a03d73f0797a4069.png";